import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { Filters } from '../api';
import { computed } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AoFilters',
  props: {
    filters: { type: Object as PropType<Filters>, required: true }
  },
  emits: ['update:filters'],
  setup(__props, { emit }) {

const props = __props



  

  // const showDownline = computed({
  //   get: () => props.filters.showDownline,
  //   set: (val) => emit('update:filters', { ...props.filters, showDownline: val })
  // })

  const search = computed({
    get: () => props.filters.search,
    set: (val) => emit('update:filters', { ...props.filters, search: val })
  })

  // const filter = reactive({
  //   downline: 'All',
  //   upline: '',
  //   contractLevel: '',
  //   customGroup: ''
  // })

  const downlineOptions = [
    'All', 'Option 1', 'Option 2', 'Option 2'
  ]

return { __sfc: true,props, emit, search, downlineOptions }
}

})